module.exports = "https://static.zego.com/_next/static/images/One-eabe2ac85c7330f47c8cca564e2d4227.svg";